namespace Gamification.Gamification {
    export interface ProdottiEsperienzeForm {
        IdProdottoEsperienza: Serenity.IntegerEditor;
        IdProdotto: Serenity.IntegerEditor;
        IdentifierEsperienza: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
        Bozza: Serenity.BooleanEditor;
        PunteggioNome: Serenity.StringEditor;
        PunteggioValoreIniziale: Serenity.IntegerEditor;
        PunteggioValoreNegativo: Serenity.BooleanEditor;
        InfluenzaPunteggioGlobale: Serenity.BooleanEditor;
        EsperienzaClassiList: ProdottiEsperienzeClassiEditor;
    }

    export class ProdottiEsperienzeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiEsperienze';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiEsperienzeForm.init)  {
                ProdottiEsperienzeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.BooleanEditor;
                var w4 = ProdottiEsperienzeClassiEditor;

                Q.initFormType(ProdottiEsperienzeForm, [
                    'IdProdottoEsperienza', w0,
                    'IdProdotto', w0,
                    'IdentifierEsperienza', w1,
                    'Nome', w1,
                    'Descrizione', w2,
                    'Bozza', w3,
                    'PunteggioNome', w1,
                    'PunteggioValoreIniziale', w0,
                    'PunteggioValoreNegativo', w3,
                    'InfluenzaPunteggioGlobale', w3,
                    'EsperienzaClassiList', w4
                ]);
            }
        }
    }
}
